import PublicPageShell from '@/components/Public/PublicPageShell'
import LegalPageLayout, { type LegalSection } from '@/components/Public/LegalPageLayout'

const UPDATED_AT = '2026-04-20'

const SECTIONS: LegalSection[] = [
  {
    id: 'acceptance',
    title: '一、协议的接受与变更',
    body: [
      '本协议是您（以下称“用户”）与 TokenTCP 之间关于注册、访问及使用 AI API 网关、模型聚合、用量计费、控制台管理等服务所订立的法律文件。当您点击注册、完成激活、创建 API Key 或以任何方式使用本服务时，即视为您已阅读、理解并同意本协议的全部内容。',
      'TokenTCP 有权根据业务运营、产品升级、合规要求或法律法规变化修订本协议。修订后的协议将在本页面公示，并可通过控制台公告、站内通知或注册邮箱提示。若您不同意修订后的条款，应立即停止使用本服务。',
    ],
  },
  {
    id: 'account-security',
    title: '二、账号与安全',
    body: [
      '您应以真实、合法、有效的信息注册和使用账号，并对账号、API Key、访问凭据及其项下发生的全部行为负责。',
      'TokenTCP 支持并建议您启用 2FA / Passkey 二次验证、IP 白名单、最小权限 API Key、敏感操作二次确认等安全措施。因您未妥善保管账号、密码、API Key、回调地址或内部授权流程导致的损失，由您自行承担。',
      '如发现任何未经授权的访问、调用异常、额度异常消耗或密钥泄露风险，您应立即在控制台禁用或删除相关 Key，并及时联系 TokenTCP 支持渠道。',
    ],
  },
  {
    id: 'usage',
    title: '三、使用规范',
    body: [
      '您承诺在使用 TokenTCP 服务过程中遵守中华人民共和国及您业务所在地、用户所在地适用的法律法规、监管要求、行业规范和第三方模型服务条款。',
      '您不得利用本服务从事包括但不限于以下行为：生成、存储、传播违法违规或侵权内容；实施网络攻击、批量爬取、撞库、滥发请求或干扰服务稳定性的行为；规避计费、安全、风控或限流机制；未经授权转售、转租、共享账号或 API Key；违反上游供应商的使用政策或内容安全规则。',
      '您应对通过 TokenTCP 发送至上游模型供应商的输入、指令、文件、图片、音频、输出结果使用方式及其合规性承担责任，并确保已取得处理相关数据所需的合法授权。',
    ],
  },
  {
    id: 'billing',
    title: '四、计费与退款',
    body: [
      'TokenTCP 采用按量计费、按次计费、套餐或分组差异化定价等商业化计费模式，具体计费单位、模型倍率、分组倍率、可用模型和价格以控制台、定价页及订单页面实时展示为准。',
      '成功完成或已被上游供应商受理的调用将依据实际用量、模型类型、分组规则和计费配置从您的账户额度或套餐权益中扣减。除法律法规另有规定、订单另有约定或 TokenTCP 主动公告的补偿安排外，已完成调用原则上不支持退款。',
      '赠送额度、活动额度、测试额度等非现金权益仅限在 TokenTCP 平台内使用，不可转让、不可提现、不可开具等额现金发票，并可能受有效期、模型范围或使用场景限制。',
    ],
  },
  {
    id: 'availability',
    title: '五、服务可用性与变更',
    body: [
      'TokenTCP 将以商业上合理的努力保障服务连续性、稳定性和可观测性，但不承诺任何时段 100% 可用，也不保证所有上游模型、渠道、价格和响应能力永久不变。',
      '因不可抗力、基础设施故障、上游供应商限制或故障、网络攻击、监管要求、第三方服务中断等原因导致服务不可用、延迟、降级或数据展示延迟的，TokenTCP 将尽快处理并通过适当渠道公告。',
      'TokenTCP 有权基于安全、合规、成本、供应商政策或产品策略调整模型、渠道、价格、限流规则和功能范围。对可能显著影响用户使用的调整，平台将尽合理努力提前公告。',
    ],
  },
  {
    id: 'ip',
    title: '六、知识产权',
    body: [
      'TokenTCP 的名称、商标、Logo、页面设计、产品文案、接口文档、控制台体验、商业配置和相关技术成果归 TokenTCP 或其合法权利人所有。未经书面授权，您不得复制、修改、反向工程、仿冒或用于任何可能造成混淆的商业用途。',
      '您保留自身业务数据、请求内容及依法享有的输出结果权利，但相关使用仍应遵守适用法律法规、第三方模型供应商条款及本协议约定。',
    ],
  },
  {
    id: 'liability',
    title: '七、免责与责任限制',
    body: [
      'AI 模型输出具有概率性和不确定性。TokenTCP 不对上游模型输出的真实性、完整性、准确性、适用性、合法性或可用于特定业务目的作出保证。您应自行对输出结果进行审核、验证和风险评估。',
      '在法律允许的最大范围内，TokenTCP 对间接损失、商誉损失、利润损失、数据损失、业务中断或第三方索赔不承担责任；就本协议项下的累计赔偿责任，以您在争议发生前最近 12 个月内实际支付给 TokenTCP 的服务费用为上限。',
    ],
  },
  {
    id: 'dispute',
    title: '八、通知与争议解决',
    body: [
      'TokenTCP 可通过控制台公告、站内消息、注册邮箱或官网 https://tokentcp.com 公示等方式向您发送通知。通知发出或公示后，即视为在合理时间内送达。',
      '本协议的订立、解释、履行及争议解决适用中华人民共和国法律。因本协议或服务使用产生争议的，双方应先友好协商；协商不成的，任一方可向 TokenTCP 运营主体所在地有管辖权的人民法院提起诉讼。',
    ],
  },
]

export default function UserAgreement() {
  return (
    <PublicPageShell contentWidth="legal-wide">
      <LegalPageLayout
        title="用户协议"
        updatedAt={UPDATED_AT}
        intro={
          <>
            请在注册、创建 API Key 或使用 TokenTCP 服务前阅读本协议，重点关注账号安全、使用规范、计费退款、免责与争议解决条款。
            您的注册和使用行为即视为您已阅读、理解并同意本协议的全部条款。
          </>
        }
        disclaimer="本页面为平台服务条款说明，供您了解 TokenTCP 服务规则。如有法律争议，以正式签署或平台公示的完整文本及适用法律为准。"
        sections={SECTIONS}
        relatedLinks={[
          { label: '隐私政策', path: '/policy' },
          { label: '关于我们', path: '/about' },
        ]}
      />
    </PublicPageShell>
  )
}
